export default "__VITE_ASSET__B5KNc4PO__"